import { Stripe, loadStripe } from '@stripe/stripe-js'
import bluebird from 'bluebird'

import {
  CreateReducer,
  CreateAction,
} from '@kaidam/fc-shared/src/frontend/store/utils/store'

import {
  IData_Booking_Single_Payment,
  IData_Booking_Single_Payment_Request,
  IData_Booking_Single_Payment_Response,
} from '@kaidam/fc-shared/src/types/schema/booking'

import {
  NetworkThunk,
} from '@kaidam/fc-shared/src/frontend/store/utils/network'

import {
  setHTTPToken,
  unsetHTTPToken,
  getHTTPTokenHeaders,
  handlers,
} from '@kaidam/fc-shared/src/frontend/store/utils/api'

import {
  REFRESH_TOKEN_DELAY,
} from '../../settings'

import {
  PaymentState,
  ReducerHandler,
  ThunkHandler,
} from '../../types/store'

const prefix = 'auth'

/*

  initial state

*/
const initialState: PaymentState = {
  
}

/*

  thunks

*/
const makeSinglePayment: ThunkHandler<IData_Booking_Single_Payment, boolean> = (payload) => async (dispatch, getState) => {
  const data = await handlers.post<IData_Booking_Single_Payment_Request, IData_Booking_Single_Payment_Response>(`/ft_booking_public/single_payment`, {
    cancel_url: document.location.href,
    success_url: `${document.location.protocol}//${document.location.host}/pay_confirm?email=${payload.email}&amount=${payload.amount}`,
    payload,
  })
  const stripe = await loadStripe(data.public_key)
  if(!stripe) throw new Error(`stripe client could not be created`)
  const {error} = await stripe.redirectToCheckout({
    sessionId: data.session.id,
  })
  if(error) throw error
  return true
}

/*

  collections

*/
const reducers = {

}

export const actions = {
  makeSinglePayment: NetworkThunk(prefix, 'makeSinglePayment', makeSinglePayment, {
    snackbar: true,
    globalLoading: {
      message: 'making payment...'
    },
  }),
}

export const reducer = CreateReducer<PaymentState>({
  prefix,
  initialState,
  reducers,
})

export default actions